export const formatDateTimeToString = (date: Date) => {
	let hour = date.getHours().toString().padStart(2, "0");
	const minute = date.getMinutes().toString().padStart(2, "0");
	const second = date.getSeconds().toString().padStart(2, "0");

	if (hour === "24") {
		hour = "00";
	}

	const formattedDate = date.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
	});

	const formattedTime = `${hour}:${minute}:${second}`;

	return { formattedDate, formattedTime };
};
